module.exports = __webpack_public_path__ + "static/media/Events.79cda05c.jpg";